module.exports = __webpack_public_path__ + "img/quizz-step-3-4.4e2847b6.jpg";